import React from 'react'

interface Props {
  options: any[]
  selected: any
  setSelected: React.Dispatch<React.SetStateAction<any>>
  className?: string
  style?: React.CSSProperties
  buttonStyle?: React.CSSProperties
  setShowDropdown: React.Dispatch<React.SetStateAction<boolean>>
}

const Dropdown: React.FC<Props> = ( props ) => {
  return (
    <div className={`bg-gray-800 border flex flex-col rounded overflow-hidden ${props.className}`} style={props.style}>
      {props.options.map(option => <button style={props.buttonStyle} onClick={() => {
        props.setSelected(option);
        props.setShowDropdown(false);
      }} className={`py-1 text-left px-2 ${option === props.selected ? 'bg-gray-700' : ''} hover:bg-gray-700`} key={`op-${option}`}>{option}</button>)}
    </div>
  )
}

export default Dropdown